
import { defineComponent } from "@vue/runtime-core"
import { mapMutations, mapState } from 'vuex'

export default defineComponent({
    name: 'BottomNav',
    methods: {
      handleSessionChange(event: Event) {
        let newSession = this.allSessions.filter((s: any) => {
          return s.doc.name == (event.currentTarget! as HTMLSelectElement).value
        })[0]
        
        this.SetCurrentSession(newSession.doc)
      },
      ...mapMutations('modalModule', ['ToggleModal', 'ToggleSessionDeleteModal']),
      ...mapMutations('sessionsModule', ['SetCurrentSession'])
    },
    computed: {
      ...mapState('sessionsModule', ['currentSession']),
      ...mapState('sessionsModule', ['allSessions']),
    }
})
